import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import { Columns, RadarFeed, DeepRead } from "./components/NewsSections";
import { Faq, About } from "./components/FaqAbout";
import FeedbackForm from "./components/FeedbackForm";
import Footer, { StructuredData } from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-paper-100">
      <StructuredData />
      <Navbar />
      <main>
        <Hero />
        <Columns />
        <RadarFeed />
        <DeepRead />
        <Faq />
        <About />
        <FeedbackForm />
      </main>
      <Footer />
    </div>
  );
}